import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-plan-item',
  templateUrl: './plan-item.component.html',
  styleUrls: ['./plan-item.component.scss']
})
export class PlanItemComponent implements OnInit {

  constructor() { }
  @Input() item: any;

  ngOnInit(): void {
  }

}
